/**
 * Map of market to URL.
 * @type {Object.<string, string>}
 */
const marketUrlMap = {
  outdoor: "https://arcteryx.com",
  outlet: "https://outlet.arcteryx.com",
  LEAF: "https://leaf.arcteryx.com",
};

/**
 * Generates a static CMS URL.
 * @param {string} market - The market.
 * @param {string} country - The country.
 * @param {string} language - The language.
 * @returns {string} The generated URL.
 * @throws {Error} If the market is not found in the map.
 */
export const generateStaticCmsUrl = (market, country, language) => {
  const baseUrl = marketUrlMap[market];

  if (!baseUrl) {
    throw new Error(`Market ${market} not found`);
  }

  if (!country || !language) {
    throw new Error("Country and Language must be provided");
  }

  return `${baseUrl}/${country}/${language}/help/search-no-result`;
};

/**
 * Gets the CMS URL.
 * @param {string} market - The market.
 * @param {string} country - The country.
 * @param {string} language - The language.
 * @returns {string|null} The CMS URL, or null if static search links are not enabled.
 */
export const getCmsUrl = (market, country, language) => generateStaticCmsUrl(market, country, language);
